import { render } from "./wheels.vue?vue&type=template&id=2cb01988&scoped=true"
import script from "./wheels.vue?vue&type=script&lang=js"
export * from "./wheels.vue?vue&type=script&lang=js"

import "./wheels.vue?vue&type=style&index=0&id=2cb01988&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb01988"]])

export default __exports__